import { Download, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

import "./installerDownload.css";


const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/installer/download`;


export default function InstallerDownloadPage() {
  return (
    <main className="installer-download-page" data-testid="installer-download-page">
      <section className="installer-download-panel" aria-labelledby="installer-download-title">
        <div className="installer-download-mark" data-testid="installer-download-icon">
          <ShieldCheck aria-hidden="true" size={30} />
        </div>
        <p className="installer-download-eyebrow">ANEKA / CASHIER BRIDGE</p>
        <h1 id="installer-download-title" data-testid="installer-download-title">
          ANEKA POS INSTALLER
        </h1>
        <p className="installer-download-copy" data-testid="installer-download-description">
          Installer siap untuk pengujian di PC Kasir.
        </p>
        <a
          className="installer-download-button"
          data-testid="download-installer-button"
          download
          href={downloadUrl}
        >
          <Download aria-hidden="true" size={20} />
          DOWNLOAD INSTALLER
        </a>
        <Link className="installer-login-link" data-testid="installer-login-link" to="/login">
          Masuk ke dashboard
        </Link>
      </section>
    </main>
  );
}